<div class="card-label-block">
	<div class="card-label">
		TODAY
	</div>
	<div class="card-total">
		Total: {{totalTime}}
	</div>

	<div class="add-record-icon" matRipple (click)="addSheet()">
		<i class="pi pi-plus-circle"></i>
	</div>
</div>

<div *ngIf="currentUser.timeCardsClosedBySystem && unResolvedCards?.length" class="unresolved-block">
  <button mat-button class="unresolved-button" (click)="editUnresolvedTimeCardButton()">
    <div class="unresolved-button-title">You are missing punch out on: {{unResolvedCards.length}} card</div>
    <div class="unresolved-button-title">Tap here to correct.</div>
  </button>
</div>

<div class="timer-box"
	[ngClass]="{'status-in': !punchedIn, 'status-out': punchedIn, 'no-job': !choosenProject || !userCoordinates}">
	<div class="flipper" [ngClass]="{'show-animation': showAnimation}">
		<div class="face front">
			<div #pie class="pie-wrapper pie-wrapper--solid progress-percent"
				[ngClass]="{'highter50': !isLower, 'lower50': isLower}"></div>
			<div class="inner-box">
				<div class="button" (click)="togglePunchStatus()">
					<div class="total-time">
					</div>
					<div class="target-label">START</div>
				</div>
			</div>
		</div>

		<div class="face back">
			<div #pieback class="pie-wrapper pie-wrapper--solid progress-percent"
				[ngClass]="{'highter50': !isLower, 'lower50': isLower}"></div>
			<div class="inner-box">
				<div class="button" (click)="togglePunchStatus()">
					<div class="total-time">
						{{lastCardTime}}
					</div>
					<div class="target-label">STOP</div>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="bottom-block">
	<div class="labels">
		<div>Clocked in</div>
		<div>Job</div>
	</div>
	<div class="time-and-job">
		<div>{{outTime$ | async}}</div>
		<div>{{choosenProject?.name}}</div>
	</div>
	<div class="buttons-block">
		<div><button mat-button class="break-button" (click)="breakOp.toggle($event)"
				[ngClass]="{'disabled-button': lastCard?.finishTime || !this.userCoordinates}"
				[disabled]="!!lastCard?.finishTime || !this.userCoordinates">Take
				Break</button></div>
		<div><button mat-button class="switch-button" (click)="switchProject()">Switch</button></div>
	</div>
</div>

<p-overlayPanel #breakOp appendTo="body" libModalOverlay styleClass="break-overlay">
	<div class="breaks">
		<div class="break paid" matRipple [matRippleCentered]="true" (click)="takeABreak('PAID_BREAK')">
			<div class="break-left">
				<div class="break-title">
					Rest Break
				</div>
				<div class="break-bottom">
					10 minutes
				</div>
			</div>
			<div class="break-right">
				<div class="break-label">
					PAID BREAK
				</div>
			</div>
		</div>
		<div class="break unpaid" matRipple [matRippleCentered]="true" (click)="takeABreak('UNPAID_BREAK')">
			<div class="break-left">
				<div class="break-title">
					Lunch Break
				</div>
				<div class="break-bottom">
					30 minutes
				</div>
			</div>
			<div class="break-right">
				<div class="break-label">
					UNPAID BREAK
				</div>
			</div>
		</div>
	</div>
</p-overlayPanel>
